<div class="relative">
  <button
    class="text-purple-600 hover:text-purple-800 hover:scale-110 transition-transform cursor-pointer"
    type="button"
    (click)="$event.stopPropagation(); isOpen = true"
    appAgentAction
    agent="import-project-popover-open"
    businessObject="project"
    [businessId]="$safeNavigationMigration(project?.id)"
    action="open"
  >
    <app-import-icon></app-import-icon>
  </button>
  <div
    role="tooltip"
    class="absolute z-10 right-4 top-6 inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-md w-72"
    [class.invisible]="!isOpen"
    [class.opacity-0]="!isOpen"
  >
    <div class="p-3 space-y-2">
      <div class="flex justify-between">
        <h3 class="font-bold text-gray-800">Import</h3>
        <app-close-icon
          class="cursor-pointer hover:scale-110 transition-transform"
          (click)="$event.stopPropagation(); isOpen = false"
          appAgentAction
          agent="import-project-popover-close"
          businessObject="project"
          [businessId]="$safeNavigationMigration(project?.id)"
          action="close"
        ></app-close-icon>
      </div>
      <div class="flex items-start gap-x-3">
        <button
          *appIfPolicySatisfied="policy.canImport"
          (click)="
            $event.stopPropagation();
            importClicked.emit({ project: project!, importType: importType.ImportAlarmMask });
            isOpen = false
          "
          type="button"
          class="text-teal-400 disabled:text-gray-400 hover:text-teal-600 cursor-pointer hover:scale-105 hover:bg-orange-100 p-0.5 rounded-md"
          appAgentAction
          agent="import-project-popover-import-alarm-mask"
          businessObject="project"
          [businessId]="$safeNavigationMigration(project?.id)"
          action="import"
        >
          <div class="flex items-start gap-x-4">
            <app-import-icon class="font-medium"></app-import-icon>
            <p class="text-xs text-gray-500 text-start">Import Alarm Masks</p>
          </div>
        </button>
      </div>
      <div class="flex items-start gap-x-3">
        <button
          *appIfPolicySatisfied="policy.canImport"
          (click)="
            $event.stopPropagation();
            importClicked.emit({ project: project!, importType: importType.ImportAlarmMaskTranslation });
            isOpen = false
          "
          type="button"
          class="text-teal-400 disabled:text-gray-400 disabled:cursor-not-allowed hover:text-teal-600 cursor-pointer hover:scale-105 hover:bg-orange-100 p-0.5 rounded-md"
          appAgentAction
          agent="import-project-popover-import-alarm-mask-translation"
          businessObject="project"
          [businessId]="$safeNavigationMigration(project?.id)"
          action="import"
        >
          <div class="flex items-start gap-x-4">
            <div class="relative font-medium">
              <app-import-icon class="font-medium"></app-import-icon>
            </div>
            <p class="text-xs text-gray-500 text-start">Import Alarm Mask translations</p>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
